import { useContext, useEffect } from 'react';
import { useMutation } from '@apollo/react-hooks';
import { addToCart } from '../../Cart/queries/addToCart.gql';
import { addToCartSuccess } from '@jetshop/core/components/Mutation/AddToCart/addToCartUtils';
import { CartIdContext } from '@jetshop/core/components/Cart/CartIdContext';
import { getSelectedProductName, getCombinedComment } from './checkComments';

export const AddCommentProduct = ({
  addedToCart,
  setAdded,
  product,
  selected
}) => {
  const documentObject = typeof document !== 'undefined' ? document : false;

  const { cartId, setCartId } = useContext(CartIdContext);

  const productArt = getSelectedProductName(product, selected);

  const quantityElement = documentObject
    ? document.querySelectorAll("input[name='quantity']")
    : false;

  const customprint = documentObject
    ? document.querySelectorAll("input[data-print-comment='true']")
    : false;

  const quantity =
    quantityElement && quantityElement.length ? quantityElement[0].value : 1;

  const comment1 =
    customprint && customprint.length > 0 ? customprint[0].value : false;

  const comment2 =
    customprint && customprint.length > 1 ? customprint[1].value : false;

  const commentCombined = comment1 && comment2;

  const printArtNo1 =
    product.customerComments?.length > 0
      ? product.customerComments[0].name
      : '';
  const printArtNo2 =
    product.customerComments?.length > 1
      ? product.customerComments[1].name
      : '';
  const printArtNoCombined =
    product.customerComments?.length > 0
      ? product.customerComments[0].name.split('1')[0] + '-combined'
      : '';

  const [addComment1] = useMutation(addToCart, {
    variables: {
      input: {
        cartId,
        articleNumber: printArtNo1,
        quantity: quantity,
        comments: [
          {
            name: 'print',
            value: comment1
          },
          {
            name: 'for',
            value: productArt
          }
        ]
      }
    },
    onCompleted: data => {
      addToCartSuccess({ cartId, setCartId })({ data });
    }
  });
  const [addComment2] = useMutation(addToCart, {
    variables: {
      input: {
        cartId,
        articleNumber: printArtNo2,
        quantity: quantity,
        comments: [
          {
            name: 'print',
            value: comment2
          },
          {
            name: 'for',
            value: productArt
          }
        ]
      }
    },
    onCompleted: data => {
      addToCartSuccess({ cartId, setCartId })({ data });
    }
  });
  const [addCommentCombined] = useMutation(addToCart, {
    variables: {
      input: {
        cartId,
        articleNumber: printArtNoCombined,
        quantity: quantity,
        comments: [
          {
            name: 'print',
            value: getCombinedComment(comment1, comment2)
          },
          {
            name: 'for',
            value: productArt
          }
        ]
      }
    },
    onCompleted: data => {
      addToCartSuccess({ cartId, setCartId })({ data });
    }
  });
  useEffect(() => {
    if (addedToCart) {
      if (commentCombined) {
        addCommentCombined();
      } else {
        if (comment1) addComment1();
        if (comment2) addComment2();
      }
      setAdded(false);
    }
  });
  return null;
};
